module.exports = __webpack_public_path__ + "img/brain.3c358096.svg";